import apiClient from './Request'
import { baseUrls } from './../const'

export default {
  RefreshToken(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/api/user/RefreshTokenv2',
      data: data
    })
  },
  Logout(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/user/Logout',
      data: data
    })
  },
  VerifyUser() {
    return apiClient.get(
      baseUrls['baseUrl'] + '/user/verifyreportinguser'
    )
  },
  GetAzureUserDetail() {
    return apiClient.get(baseUrls['baseUrl'] + '/user/GetAzureUserDetail')
  },
  GetReportConfiguration(organisationId, showPID) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/configurations/getreportconfigbyorganisationid?organisationId=' +
        organisationId +
        '&showPID=' +
        showPID
    )
  },
  GetReportInPdf(organisationId, data) {
    return apiClient({
      method: 'post',
      url:
        baseUrls['commonBaseUrl'] +
        '/user/getreportinpdf?tenantId=' +
        organisationId,
      data: data,
      responseType: 'blob'
    })
  },
  GetOrganisationShift(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/Organisation/getorganisationshift?organisationId=' +
        organisationId
    )
  },
  SaveOrganisationShift(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/Organisation/saveorgshift',
      data: data
    })
  },
  GetOrganisationBaselineTrial(organisationId) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/Organisation/getorganisationbaselinetrial?organisationId=' +
        organisationId
    )
  },
  SaveOrganisationBaselineTrial(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/Organisation/saveorgbaselinetrialdate',
      data: data
    })
  },
  DeleteOrgShif(id) {
    return apiClient.delete(
      baseUrls['baseUrl'] + '/Organisation/DeleteOrgShift?id=' + id
    )
  },
  UpdateOrganisationAudit(orgId, data) {
    return apiClient({
      method: 'put',
      url: baseUrls['baseUrl'] + '/setting/UpdateOrganisationAudit?organisationId=' + orgId,
      data: data
    })
  }
}
